import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  src: "/static/img/user-icon.png",
  alt: ""
}
const _hoisted_2 = {
  key: 0,
  class: "p-icon-user-image__upload"
}
const _hoisted_3 = {
  key: 1,
  class: "p-icon-user-image__unread"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "p-icon-user-image",
    style: _normalizeStyle(_ctx.setStyleObj)
  }, [
    _createElementVNode("div", {
      class: "p-icon-user-image__inner",
      style: _normalizeStyle(_ctx.setStyleObj)
    }, [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        (!_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("img", _hoisted_1))
          : _createCommentVNode("", true)
      ], true),
      (_ctx.upload)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2))
        : _createCommentVNode("", true),
      (_ctx.unread)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[0] || (_cache[0] = [
            _createElementVNode("i", { class: "p-icon-user-image__unread__dot" }, null, -1)
          ])))
        : _createCommentVNode("", true)
    ], 4)
  ], 4))
}